import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { fromUTC, getCurrentYearInTimeZone } from "../../utils/dateUtil";
import { axiosPrivate } from "../../axios/axios";
import Loading from "../../Component/Loading";
import NormalTable from "../../Component/NormalTable";
import ResponsiveDialog from "../../Component/ResponsiveDialog";
import { color } from "../../StyleData/Config";
import { masterAPI } from "../Masters/dataConfig";

const baseMonthListColumns = [
  { Header: "WO Code", accessor: "workOrderCode" },
  { Header: "Work Order", accessor: "workOrderName" },
  { Header: "Work Type", accessor: "workTypeName" },
  { Header: "Month", accessor: "month" },
  { Header: "Status", accessor: "status" },
  { Header: "Total Hours", accessor: "totalHours" },
  { Header: "WO Hours", accessor: "workedHours" },
];

const dateColumns = [
  {
    Header: "Planned Start Date",
    accessor: "plannedStartDate",
    Cell: ({ cell }) => (cell.value ? fromUTC(cell.value).tzString : "N/A"),
  },
  {
    Header: "Actual Start Date",
    accessor: "actualStartDate",
    Cell: ({ cell }) => (cell.value ? fromUTC(cell.value).tzString : "N/A"),
  },
];

const KPIHour = ({
  apiEndpoint,
  listApiEndpoint,
  title = "KPI Hour",
  colors = ["#FF0000", "#008FFB"],
  legendColors = "black",
  xAxisLabelColor = "black",
  showDateColumns = false,
}) => {
  const monthListColumns = showDateColumns
    ? [...baseMonthListColumns, ...dateColumns]
    : baseMonthListColumns;

  const [series, setSeries] = useState({});
  const [loading, setLoading] = useState(true);
  const [monthDialog, setMonthDialog] = useState({
    open: false,
    month: "",
    loading: false,
    data: [],
  });
  console.log(apiEndpoint, "apiEndpoint");
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const currentYear = getCurrentYearInTimeZone();
      const response = await axiosPrivate.post(
        `${apiEndpoint}?year=${currentYear}`,
      );

      const apiData = response.data.result || response.data || [];
      setSeries(apiData);
    } catch (err) {
      setSeries({});
    } finally {
      setLoading(false);
    }
  };

  const handleBarClick = (dataPointIndex) => {
    if (!listApiEndpoint) return;

    const monthLabel = series?.months?.[dataPointIndex];
    if (!monthLabel) return;

    const currentYear = getCurrentYearInTimeZone();
    const month = dataPointIndex + 1;

    // Deferred to the next tick so opening the dialog doesn't mutate the
    // DOM while ApexCharts is still finishing its own click handling
    // (otherwise it can throw reading getBoundingClientRect on a removed node).
    setTimeout(() => {
      setMonthDialog({ open: true, month: monthLabel, loading: true, data: [] });

      axiosPrivate
        .post(`${listApiEndpoint}?year=${currentYear}&month=${month}`)
        .then((res) => {
          const listData = res.data.result || res.data || [];
          setMonthDialog((prev) => ({ ...prev, loading: false, data: listData }));
        })
        .catch((err) => {
          console.log(err, "KPIHour month list fetch error");
          setMonthDialog((prev) => ({ ...prev, loading: false, data: [] }));
        });
    }, 0);
  };

  const handleCloseMonthDialog = () => {
    setMonthDialog({ open: false, month: "", loading: false, data: [] });
  };

  //   const chartHeight = series?.months.length > 5
  //   ? series?.calculative.length * 60
  //   : 350;

  //     const options = {
  //       chart: {
  //         height: chartHeight,
  //         type: "line",
  //         toolbar: {
  //             export: {
  //               csv: {
  //                 filename: title,
  //               },
  //               svg: {
  //                 filename: title,
  //               },
  //               png: {
  //                 filename: title,
  //               },
  //             },
  //           },
  //       },
  //        responsive: [
  //         {
  //           breakpoint: 1024,
  //           options: {
  //             chart: { height: 300 }
  //           }
  //         },
  //         {
  //           breakpoint: 768,
  //           options: {
  //             chart: { height: 250 }
  //           }
  //         }
  //       ],

  //       noData: {
  //         text: "No Data Available",
  //         align: "center",
  //         verticalAlign: "middle",
  //         style: {
  //           color: "#999",
  //           fontSize: "14px"
  //         }
  //       },

  //       title: {
  //         text: title,
  //         align: "center",
  //         style: { color: titleColor },
  //       },
  //       stroke: {
  //         width:  [0, 3],
  //       },
  //       dataLabels: {
  //         enabled: true,
  //       },
  //       labels: series?.months || [],
  //       colors: colors,
  //       yaxis: {
  //         labels: {
  //           formatter: (val) => val + "%"
  //         },
  //       },
  //       legend: {
  //         labels: {
  //           colors: legendColors,
  //         },
  //       },
  //       xaxis: {
  //         labels: {
  //           style: { colors: xAxisLabelColor },
  //         },
  //       },
  //     };

  //     const seriesData = [
  //       {
  //         name: "Average of Percentage Man Hour PM",
  //         type: "column",
  //         data: series?.calculative || []
  //       },
  //       {
  //         name: "Average of Target 40%",
  //         type: "line",
  //         data: series?.targetLine || []
  //       }
  //     ];

  return (
    <>
      {listApiEndpoint && (
        <style>{`.kpi-hour-clickable .apexcharts-bar-area { cursor: pointer; }`}</style>
      )}
      {loading ? (
        <Loading />
      ) : (
        <Chart
          className={listApiEndpoint ? "kpi-hour-clickable" : undefined}
          options={{
            chart: {
              height: 350,
              type: "line",
              toolbar: {
                show: true,
                tools: {
                  download: true,
                  selection: false,
                  zoom: false,
                  zoomin: false,
                  zoomout: false,
                  pan: false,
                  reset: false,
                },
                export: {
                  csv: {
                    filename: title,
                  },
                  svg: {
                    filename: title,
                  },
                  png: {
                    filename: title,
                  },
                },
              },
              events: {
                dataPointSelection: (event, chartContext, config) => {
                  handleBarClick(config.dataPointIndex);
                },
              },
            },
            responsive: [
              {
                breakpoint: 1024,
                options: {
                  chart: { height: 300 },
                },
              },
              {
                breakpoint: 768,
                options: {
                  chart: { height: 250 },
                },
              },
            ],

            noData: {
              text: "No Data Available",
              align: "center",
              verticalAlign: "middle",
              style: {
                color: "#999",
                fontSize: "14px",
              },
            },

            title: {
              text: title,
              style: {
                fontFamily: "Nunito Sans, sans-serif",
                color: "#2362B4",
              },
            },
            stroke: {
              width: [0, 3],
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: false,
                dataLabels: {
                  position: "center",
                },
              },

              stroke: {
                width: 1,
                colors: ["#fff"],
              },
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: [0, 1],
              formatter: function (val) {
                return val + "%";
              },
              //    style: {
              //     //   fontSize: '12px',
              //     padding: "0px 4px",
              //       colors: ['#fff'], // Keep text white
              //       fontWeight: 'bold',
              //     },
              //     background: {
              //       enabled: false, // This removes the white background/border
              //     },
              //     dropShadow: {
              //       enabled: false // Also ensures no shadow remains
              //     }
            },
            labels: series?.months || [],
            colors: colors,
            yaxis: {
              labels: {
                formatter: (val) => val + "%",
              },
            },
            legend: {
              labels: {
                colors: legendColors,
              },
            },
            xaxis: {
              labels: {
                style: { colors: xAxisLabelColor },
              },
            },
          }}
          series={[
            {
              name: "Average of Percentage Man Hour",
              type: "column",
              data: series?.calculativeHours || [],
            },
            {
              name: `Average of Target ${series?.targetLine[0] || 40}%`,
              type: "line",
              data: series?.targetLine || [],
            },
          ]}
          type={"line"}
          height={350}
        />
      )}

      <ResponsiveDialog
        open={monthDialog.open}
        onClose={handleCloseMonthDialog}
        maxWidth="xl"
        fullWidth
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography
              sx={{
                color: color.masterPageTitleColor,
                fontSize: color.masterPageTitleFontSize,
                fontWeight: color.masterPageTitleFontWeight,
                mb: color.masterPageTitlemd,
                px: 2,
                py: 1,
              }}
            >
              {title} —{" "}
              <span style={{ color: color.masterDialogTitleColor }}>
                {monthDialog.month}
              </span>
            </Typography>
            <Box sx={{ px: 2, py: 1 }}>
              {monthDialog.loading ? (
                <Loading />
              ) : monthDialog.data.length === 0 ? (
                <Typography
                  sx={{ textAlign: "center", color: "#999", fontSize: "14px", py: 4 }}
                >
                  No Data Available
                </Typography>
              ) : (
                <NormalTable
                  data={monthDialog.data}
                  columns={monthListColumns}
                  filt={true}
                />
              )}
            </Box>
          </Grid>
          <Divider />
          <Grid container item justifyContent="flex-end">
            <Button onClick={handleCloseMonthDialog}>Close</Button>
          </Grid>
        </Grid>
      </ResponsiveDialog>
    </>
  );
};

export default KPIHour;